import { render } from "./Lightbox-Owner.vue?vue&type=template&id=5a547806"
import script from "./Lightbox-Owner.vue?vue&type=script&lang=js"
export * from "./Lightbox-Owner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__